import React from "react"
import styled from "styled-components"

const StyledP = styled.p`
    margin: 0;
    color: ${(props) => props.color || "var(--muted)"};
    font-size: ${(props) => props.size || "1rem"};
    font-weight: ${(props) => props.weight || 500};
    line-height: 1.72;
    text-align: ${(props) => props.align || "left"};
`

function P ({children, color, size, weight, align}) {
    return (
        <StyledP color={color} size={size } weight={weight} align={align}>
            {children}
        </StyledP>
    )
}

export {P}
export default P
